import React from "react";
import moment from "moment";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as userActions from "../../../actions/user";
import * as assayActions from "../../../actions/assays";
import * as cartActions from "../../../actions/addToCart";
import * as config from "../../../app.config";
import { Helmet } from "react-helmet";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import { isCrawlable } from "../../../util/validations";
import ScrollToTop from "../Misc/ScrollToTop";

import Toaster from "../Misc/Toaster.jsx";
import Nav from "./Nav.jsx";

import "../../../scss/global.scss";

const styles = () => ({
  root: {},
});

class AppWrapper extends React.Component {
  componentDidMount() {
    const { actions } = this.props;
    actions.fetchUserDetail();
    actions.fetchCartCount();
  }

  handleLogout(e) {
    e.preventDefault();
  }
  render() {
    const {
      classes,
      children,
      id,
      user,
      authenticating,
      pageTitle,
      pageDescription,
      pageKeywords,
      messages,
      assayCartHtml,
      actions,
      history: {
        location: { pathname },
      },
    } = this.props;
    const initialLocationPath =
      (pathname && pathname.split("digital-assays")[1]) || "";
    const userName = (user && user.webUserName) || false;
    const userAuthenticated = (user && user.loggedIn) || false;
    const crawlable = isCrawlable(window.navigator.userAgent || "");
    const needsRedirect =
      !config.ISLOCALHOST &&
      !authenticating &&
      !userAuthenticated &&
      pathname &&
      !crawlable &&
      pathname.indexOf("digital-assays") !== -1;
    const redirectUrl = encodeURIComponent(
      `${document.location.protocol}//${document.location.host}/digital-assays${initialLocationPath}`
    );
    if (needsRedirect) {
      return (window.location.href = `/en-us/login-registration?redirectUrl=${redirectUrl}`);
    }

    return (
      <div className={classes.root} id={id}>
        <Helmet>
          <title>Bio-Rad Droplet Digital PCR Assays | {pageTitle || ""}</title>
          <meta name="description" content={pageDescription || ""} />}
          <meta name="keywords" content={pageKeywords || ""} />}
        </Helmet>
        <ScrollToTop />
        <div id="header" className="bg-white d-print-none">
          <div className="row d-flex justify-content-around">
            <div className=" col-lg-3 col-md-3 col-sm-2">
              <a href="/en-us/category/digital-pcr-assays?ID=PD2R1IRT8IG9">
                <img
                  src={require("../../../digital-assays/assets/images/logo-min.png")}
                  alt="Bio Rad"
                  id="logo"
                />
              </a>
            </div>
            {userName && (
              <div className="col-lg-9 col-md-9 col-sm-3 justify-content-end">
                {assayCartHtml}
                <span id="user-info">
                  Welcome back, {userName}{" "}
                  <a href={`/en-us/ssologout?tstamp=${moment().unix()}`}>
                    Log Out
                  </a>{" "}
                  | <a href="/en-us/my-bio-rad">My Bio-Rad</a> |{" "}
                  <a href="/en-us/contact-us">Contact Us</a>
                </span>
              </div>
            )}
          </div>
        <Nav />
        </div>

        {!authenticating && children}

        <div id="footer" className="d-print-none">
          <div className="container">
            <div className="row">
              <div className="col-md-3">
                <h4>Support</h4>
                <ul>
                  <li>
                    <a
                      className="msdsLink wtclass linkgeneration"
                      href="/en-us/literature-library"
                    >
                      MSDS
                    </a>
                  </li>
                  <li>
                    <a
                      className="cofaLink wtclass linkgeneration"
                      href="/en-us/life-science-research/support/certificate-of-analysis"
                    >
                      Certificate of Analysis
                    </a>
                  </li>
                  <li>
                    <a
                      href="http://myeinserts.qcnet.com/"
                      title="Link opens in new window"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      QC Inserts&nbsp;
                      <i className="fas fa-external-link-alt icon-new-window" />
                    </a>
                  </li>
                  <li>
                    <a href="/en-us/life-science-research/purchase-service-programs/expert-care-service">
                      Expert Care Service
                    </a>
                  </li>
                  <li>
                    <a href="/en-us/contact-us">Feedback</a>
                  </li>
                  <li>
                    <a href="/en-us/contact-us">Contact Us</a>
                  </li>
                </ul>
              </div>
              <div className="col-md-3">
                <h4>Ordering</h4>
                <ul>
                  <li>
                    <a id="quickOrderLink">Quick Order</a>
                  </li>
                  <li>
                    <a
                      className="mybioradLink wtclass linkgeneration"
                      href="/en-us/my-bio-rad"
                    >
                      My Bio-Rad
                    </a>
                  </li>
                  <li>
                    <a href="/prd/en/US/direct/biorad?ts=1&amp;cmd=OrdersWorkspaceDisplay">
                      Order History
                    </a>{" "}
                  </li>
                  <li>
                    <a href="/prd/en/US/direct/biorad?ts=1&amp;cmd=InvoiceWorkspaceDisplay&amp;_Tab=Invoice">
                      Invoice History
                    </a>
                  </li>
                  <li>
                    <a href="/prd/en/US/direct/biorad?ts=1&amp;cmd=QuotesWorkspaceDisplay">
                      Quote History
                    </a>{" "}
                  </li>
                  <li>
                    <a href="/en-us/life-science-research/purchase-service-programs/supply-center-program">
                      Supply Centers
                    </a>
                  </li>
                </ul>
              </div>
              <div className="col-md-3">
                <h4>Our Products</h4>
                <ul>
                  <li>
                    <a href="/en-us/life-science-research">
                      Life Science Research
                    </a>
                  </li>
                  <li>
                    <a href="/en-us/clinical-diagnostics">
                      Clinical Diagnostics
                    </a>
                  </li>
                  <li>
                    <a href="/en-us/spectroscopy">Spectroscopy</a>
                  </li>
                  <li>
                    <a href="/en-us/process-separations">Process Separations</a>
                  </li>
                  <li>
                    <a href="/en-us/food-science">Food Science</a>
                  </li>
                  <li>
                    <a href="/en-us/education">Life Science Education</a>{" "}
                  </li>
                  <li>
                    <a href="/featured/en/selection-guides.html">
                      Selection Guides
                    </a>
                  </li>
                  <li>
                    <a href="/featured/en/featured-products.html">
                      Featured Products
                    </a>
                  </li>
                </ul>
              </div>
              <div className="col-md-3">
                <h4>Corporate</h4>
                <ul>
                  <li>
                    <a href="/en-us/corporate/about-bio-rad">About Bio-Rad</a>
                  </li>
                  <li>
                    <a href="/en-us/corporate/careers">Careers</a>{" "}
                  </li>
                  <li>
                    <a href="/en-us/corporate/investor-relations">
                      Investor Relations
                    </a>
                  </li>
                  <li>
                    <a href="/en-us/corporate/community-outreach">
                      Community Outreach
                    </a>
                  </li>
                  <li>
                    <a href="/en-us/corporate/protecting-environment">
                      Protecting the Environment
                    </a>
                  </li>
                  <li>
                    <a href="/en-us/corporate/newsroom">Newsroom</a>{" "}
                  </li>
                </ul>
              </div>
            </div>

            <div className="row" id="footer-bottom">
              <div className="col-md-12 text-center">
                <a href="/">Home</a>&nbsp;|&nbsp;<a href="/en-us/help">Help</a>
                &nbsp;|&nbsp;
                <a href="/en-us/contact-us?verticalName=life-science-research">
                  Contact Us
                </a>
                &nbsp;|&nbsp;<a href="/en-us/corporate/careers">Careers</a>
                &nbsp;|&nbsp;<a href="/en-us/trademarks">Trademarks</a>
                &nbsp;|&nbsp;
                <a href="/en-us/site-terms">Site Terms</a>&nbsp;|&nbsp;
                <a href="/en-us/privacy">Privacy</a>&nbsp;|&nbsp;
                <a href="">Feedback</a>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 text-center">
                <p>
                  <small>
                    Copyright &copy; {moment().format("YYYY")} Bio-Rad
                    Laboratories, Inc. All rights reserved.
                  </small>
                </p>
              </div>
            </div>
          </div>
        </div>

        {messages &&
          messages.map((message) => (
            <Toaster
              text={message.text}
              autoHideDuration={3000}
              type={message.displayType}
              key={message.key}
              actions={actions}
            />
          ))}
      </div>
    );
  }
}

AppWrapper.propTypes = {
  classes: PropTypes.object,
  actions: PropTypes.object,
  history: PropTypes.object,
  user: PropTypes.object,
  id: PropTypes.string,
  assayCart: PropTypes.array,
  message: PropTypes.array,
  pageTitle: PropTypes.string,
  authenticating: PropTypes.bool,
  messages: PropTypes.array,
  assayCartHtml: PropTypes.array,
};

const stateToProps = (state) => ({
  assayCartHtml: (state.addToCart && state.addToCart.assayCartHtml) || [],
  user:
    (state.user && state.user.evoSession && state.user.evoSession.data) || {},
  authenticating: state.user && state.user.authenticating,
  messages: (state.assays && state.assays.messages) || [],
});

const dispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    Object.assign({}, userActions, cartActions, assayActions),
    dispatch
  ),
});

AppWrapper = withRouter(connect(stateToProps, dispatchToProps)(AppWrapper));

export default withStyles(styles, { withTheme: true })(AppWrapper);
